import api from '../../api'
import router from '../../router';
import {encrypt, decrypt} from "../../helpers/encryption";


const state = {
    user: null,
    token: null,
    lang: localStorage.getItem('lang')?localStorage.getItem('lang'):'NL'
};

// getters
const getters = {};

// actions
const actions = {
    //Check if user is still logged in and refresh the access token.
    _loggedIn({commit, dispatch}){
        return new Promise((resolve, reject) => {
            if (state.token !== null) {
                resolve();
            } else {
                const encryptedAccessToken = localStorage.getItem('access_token');
                if (encryptedAccessToken !== null) {
                    const accessToken = decrypt(encryptedAccessToken);
                    dispatch('_init', accessToken).then(resolve).catch(reject);

                } else {
                    commit('setToken', false);
                    reject();
                }
            }
        });
    },
    //Login user
    _login ({dispatch}, cred) {
        console.log(cred);
        return new Promise((resolve, reject) => {
            //Prepare request data
            const data = {
                grant_type: 'password',
                client_id: 2,
                client_secret: '0cuvEmZqWjuuQ4wb1sWGp0qyHjeciJDjNflTOGvs',
                username: cred.username,
                password: cred.password
            };
            //Request token with credentials from server
            api.post( '/oauth/token', data).then(response => {
                console.log(response);
                //Save encrypted refresh token in localstorage
                const encryptedRefreshToken = encrypt(response.data.refresh_token);
                const encryptedAccessToken = encrypt(response.data.access_token);
                localStorage.setItem("refresh_token", encryptedRefreshToken);
                localStorage.setItem("access_token", encryptedAccessToken);
                //Add authorization header for future requests
                dispatch('_init', response.data.access_token).then(()=>{
                    resolve(response.data);
                }).catch(reject);

            }).catch((error) => {
                console.log(error);
                reject(error.response.data);
            });
        });
    },
    //Forgot your password
  // eslint-disable-next-line
    _resetPassword ({}, username) {
        return new Promise((resolve, reject) => {
            const data = {
                username: username,
            };
            api.post('/admin/reset', data).then(response => {
                if(response.status === 204) {
                    resolve(response.data);
                }
            }).catch((error) => {
                reject(error.response.data);
            });
        });
    },
    //Logout user
    _logout({commit}){
        return new Promise((resolve) => {
            //Remove from local storage
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("access_token");
            //Remove user from store
            commit('setUser', null);
            commit('setToken', false);
            router.replace('/login');
            resolve(true);
        });
    },
    //Retrieve logged in user
    _getUser({commit, state}, force = false){
        return new Promise((resolve, reject) => {
            if(state.user === null || force) {
                api.get('admin/me').then(response => {
                    console.log(response);
                    //Set the user state
                    const user = response.data.data;
                    commit('setUser', user);
                    resolve(user);
                }).catch((error) => {
                    console.log(error);
                    reject(error.response.data);
                });
            }
            else{
                resolve(state.user);
            }
        });
    },
    _init({commit, dispatch, state}, accessToken){
        api.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
        api.defaults.headers.common['x-country'] = state.lang;
        commit('setToken', accessToken);
        const promises = [
            dispatch('_getUser'),
        ];
        return Promise.all(promises);
    }
};

// mutations
const mutations = {
    setUser(state, user){
        state.user = user;
    },
    setToken(state, token){
        state.token = token;
    },
    setLanguage(state, lang) {
        localStorage.setItem('lang', lang);
        location.reload();
        state.lang = lang;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
